import React from 'react';
import TabView from './TabView';
import { WorkflowStatusManageWrapper } from './CustomStatus/Context/WorkflowStatusManageWrapper';
import { WorkflowManageWrapper } from './CustomStatus/Context/WorkflowManageWrapper';
import { FolderWorkflowManageWrapper } from './FolderWorkflow/FolderWorkflowManageWrapper';



export const WorkflowSettingsManage = ({ onClose }) => {
    return (
        <>
            <div className="settings-view__manage__container">
                <div className="m-2">
                    <div className="settings-view-modal">
                        <div style={{ minHeight: '80%', fontSize: '13px', height: 'calc(100% - 30px)' }}>
                            <button
                                id="editor-close-btn"
                                type="button"
                                className="close modal-close"
                                title="Close Modal"
                                style={{ zIndex: 4 }}
                                onClick={onClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <h3 className="">Workflow Settings</h3>
                            <hr></hr>                            
                            <TabView                                                        
                                tabItems={[
                                    {
                                        title: 'Workflow',
                                        content: WorkflowManageWrapper
                                    },
                                    { title: 'Workflow Status', content: WorkflowStatusManageWrapper },
                                    { title: 'Folder Workflow', content: FolderWorkflowManageWrapper }
                                ]}
                            />
                        </div>                       
                    </div>
                </div>
            </div>
        </>
    );
};
